import { render, staticRenderFns } from "./issue-home-header-actions.vue?vue&type=template&id=46600084"
import script from "./issue-home-header-actions.vue?vue&type=script&lang=js"
export * from "./issue-home-header-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports